import * as React from 'react'

function SvgTowingEyeChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0ZM18.86 15.258l2.5.5a9.026 9.026 0 0 0 4.7 3.75c.169.462.279.952.322 1.464.057.687.103 1.39.118 2.01.04 1.702-1.36 3.024-3 3.024h-.626a4.002 4.002 0 0 1-7.75-.006H8v-2h7.127a4.002 4.002 0 0 1 7.747.006h.626c.58 0 1.013-.46 1-.976a33.249 33.249 0 0 0-.111-1.892c-.139-1.655-1.4-3.014-3.086-3.351l-2.835-.567a7 7 0 0 1-2.51-1.04l-3.46-2.307-3.026-1.513A5 5 0 0 0 8 11.891V9.875l.104.011a7 7 0 0 1 2.263.685l3.136 1.569 3.564 2.376a5 5 0 0 0 1.793.742ZM17 25.005a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM29.17 24.005H27v-2h2.17a3.001 3.001 0 1 1 0 2Zm1.83-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
      />
    </svg>
  )
}

export default SvgTowingEyeChecked
